import { Injectable } from '@angular/core';
import { Observable, EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

/**
 * Best-effort version poll against /version.json.
 * Network aborts / status 0 must soft-fail (MO-FE-7K) — never bubble to Sentry.
 */
@Injectable()
export class LatestVersionService {
    private url = '/version.json';

    constructor(private http: HttpClient) { }

    get(): Observable<any> {
        return this.http.get<any>(this.url).pipe(
            catchError(() => EMPTY)
        );
    }

}
